import { openLoginDialog } from '@/components/LoginDialog/openLoginDialog'
import { getCookie } from './cookie'
import { history } from 'umi'
import { baseState } from '@/states/store'
import openPayDialog from '@/components/PayDialog'
import { subscribe } from 'valtio'
import { MemberType } from '@/constants'
import { openMaskCoupon } from '@/components/MaskCoupon/openMaskCoupon'
import openIntercept from '@/components/PayInterceptTourist'
import { openBindTel } from '@/components/BindTel/openBindTel'

const openPay=(pathname:string, cb?: any)=>{
  console.log('openPay-->pathname',pathname)
  openPayDialog({
    type: 1,
    needBindTel:false,
    onClose: (userInfo: any) => {
      if(!userInfo.isBindMobile&&userInfo?.memberStatus === MemberType.已开通){
        openBindTel({
          close:false,
          cb:()=>{
              cb ? cb() : history.push({
                pathname,
              })
          }
        })
      }else if(userInfo?.memberStatus === MemberType.已开通){
        cb ? cb() : history.push({
          pathname,
        })
      }else{
        if(/create\/marketing-poster/.test(pathname)||/create\/product-details/.test(pathname)){
          openIntercept({pathName:pathname, cb, from: 'route', userInfo})
        }
      }

    },
  })
}

// 首页的海报创作相似，需要判断是否登录、是否会员、是否9.9、是否拦截等等，判断条件结束后cb()
const userGoto = (pathname: string, event?: string, cb?: any) => {
  const isMember = baseState?.userInfo?.memberStatus === MemberType.已开通
  pathname || (pathname = '')
  if (event) {
    switch (event) {
      case 'checkMemberStatus':
        console.log('🚀 ~ userGoto ~ checkMemberStatus:', isMember)
        if (isMember) {
          cb ? cb() : history.push({
            pathname,
          })
        } else {
          console.log('优惠券非会员',pathname)
          if (
            !baseState?.userInfo?.specialInfo?.isBuyGoods10 &&
            baseState?.userInfo.balance != undefined &&
            baseState?.userInfo?.balance <= 200
          ) {
            openMaskCoupon({
              type:'active',
              cb,
              pathName:pathname,
              callback:(res)=>{
                console.log('优惠券路由callback===》',res)
                if(!res){
                  openPay(pathname, cb)
                }
              },
            })
          }else{
            console.log('优惠券不满足===》直接弹弹窗',pathname)
            openPay(pathname, cb)
          }
        }
        break

      default:
        break
    }
  } else {
    switch (pathname) {
      case 'event:pay':
        openPayDialog({type:2})
        break
      default:
        cb ? cb() : history.push({
          pathname,
        })
    }
  }
}

export default (pathname: string, event?: string, cb?: any) => {
  pathname || (pathname = '')
  if (getCookie('token')) {
    if (baseState.isLogin) {
      userGoto(pathname, event, cb)
    } else {
      userGoto(pathname, event, cb)
      location.reload()
    }
  } else {
    openLoginDialog({
      onClose: () => {
        if (pathname && getCookie('token')) {
          userGoto(pathname, event, cb)
        }
      },
    })
  }
}
